<template>
  <div :class="{
    'sub-layer-checkbox': true,
    'sub-layer-checkbox--checked': checked,
  }">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

const LayerCustom: object = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: true,
      name: 'checked',
    },
    parentState: {
      type: Boolean,
      default: true,
      name: 'parentState',
    },
  },
  name: 'LayerCustom',
  setup() {

    return {
    };
  },
});
export default LayerCustom;
</script>

<style scoped lang="scss">

.sub-layer-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: rem(32px);
  margin-bottom: rem(8px);

  &__content {
    border: 4px solid rgba($nav-sub-item-border-rgb, 0.33);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: rem(34px);
    height: rem(34px);
  }

  &:not(:last-of-type) {
    @include width-from($mobile) {
      // margin-bottom: rem(8px);
    }
  }

  &__row {
    width: 100%;
    height: 100%;
    background-color: $nav-sub-item-bg;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    opacity: 1;
    transition: opacity ease-in-out 0.3s;
  }

  &__icon-wrapper {
    display: flex;
    align-items: center;
  }

  &--checked {
    .sub-layer-checkbox__row {
      background-color: $nav-sub-item-active-bg;
    }
    .sub-layer-checkbox__content {
      border: 4px solid rgba($nav-sub-item-active-border-rgb, 0.33);

      .dark-theme & {
        border-color: $static_red_light;
        background-color: $yellow-static;
      }
    }
  }

  &__input {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    background: transparent;
    bottom: 0;
    left: 0;
    right: 0;


    input {
      opacity: 0;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 2;
      cursor: pointer;
    }

    &--checked {
      &:after {
        opacity: 1;
      }
    }
  }

  &__icon {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      height: 100%;
      font-size: rem(12px);
      color: $font-white;

      &::before {
        color: currentColor;
      }
    }
  }

  &__title {
    word-wrap: break-spaces;
    letter-spacing: rem(0.7px);
    font-weight: 500;
    line-height: 0.875;
    white-space: nowrap;
    padding: rem(4px) rem(8px);
    border-radius: rem(14px);
    transition: .5s;
    color: $main-font-color;
    background-color: $main-bg-color;

    pointer-events: none;
    font-size: rem(10px);
    font-weight: 700;
    border: 1px solid $main-bg-color;

    &:hover {
      text-decoration: none;
    }
  }

  &__label {
    display: none;
  }
}
</style>
